import { useMutation, useQuery } from "@tanstack/react-query";
import axiosBaseURL from "..";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import { message } from "antd";

export const useAdminDashboard = () => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["admin dashboard values"],
    staleTime: 1200,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/off-taker/dashboard/`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetLookup = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["lookup"],
    staleTime: 1200,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/lookups`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetOutputPrice = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["output price"],
    staleTime: 1200,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/prices`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetInputPrice = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["input price"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/inputPrice`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetOutputPriceById = (id?: string | number) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["output price", id],
    staleTime: 1200,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/price?id=${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useCreateOutputPrice = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useGetOutputPrice();
  return useMutation({
    mutationFn: async (data: {
      outPutId: number;
      warehouseId: number;
      priceCycle: number;
      contractPrice: number;
      spotPrice: number;
      year: number;
    }) => {
      const result = await axiosBaseURL.post(`/admin/price/add`, data, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      refetch();
      return result;
    },
  });
};

export const useCreateInputPrice = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useGetInputPrice();
  return useMutation({
    mutationFn: async (data: any) => {
      const result = await axiosBaseURL.post(`/admin/inputPrice/add`, data, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      refetch();
      return result;
    },
  });
};

export const useUpdateInputPrice = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useGetInputPrice();
  return useMutation({
    mutationFn: async (data: any) => {
      const result = await axiosBaseURL.put(
        `/admin/inputPrice/${data.id}/edit`,
        data,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      refetch();
      return result;
    },
  });
};

export const useUpdateOutputPrice = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useGetOutputPrice();
  return useMutation({
    mutationFn: async (data: {
      id: number;
      price: {
        outPutId?: number;
        warehouseId?: number;
        priceCycle?: number;
        contractPrice?: number;
        spotPrice?: number;
        year?: number;
      };
    }) => {
      const result = await axiosBaseURL.put(
        `/admin/price/edit?id=${data.id}`,
        data.price,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      refetch();
      return result;
    },
  });
};

export const useOffTakersList = () => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["admin dashboard"],
    staleTime: 1200,
    queryFn: async () => {
      // const result = await axiosBaseURL.get(`/admin-dashboard/`, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         // Authorization: authString,
      //     }
      // });

      const result = {
        status: "success",
        message: "message",
        data: {
          numberOfOfftakers: 10,
          numberOfOrders: 124,
          numberOfCustomers: 279,
          numberOfContracts: 547,
        },
      };

      return result;
    },
  });
};

export const useWarehouseList = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useWarehouseList"],
    staleTime: 1200,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/centers`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetWarehouseById = (id?: number) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["warehouse by id"],
    staleTime: 1200,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/center?id=${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetInputPriceById = (id?: number) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["inpit price by id", id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/inputPrice/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useCountryStruct = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["country struct-"],
    staleTime: 1200,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/center/countryStruct`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useCreateWarehouse = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useWarehouseList();
  return useMutation({
    mutationFn: async (data: {
      centerName: string;
      capacity: number;
      woredaId: number;
    }) => {
      const result = await axiosBaseURL.post(`/admin/center/create`, data, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      refetch();
      return result;
    },
  });
};

export const useUpdateWarehouse = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useWarehouseList();
  return useMutation({
    mutationFn: async (data: {
      id: number;
      warehouse: { centerName: string; capacity: number; woredaId: number };
    }) => {
      const result = await axiosBaseURL.patch(
        `/admin/center/edit?id=${data.id}`,
        data.warehouse,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );

      refetch();
      return result;
    },
  });
};

export const useDeleteWarehouse = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useWarehouseList();
  return useMutation({
    mutationFn: async (id: number) => {
      const result = await axiosBaseURL.patch(
        `/admin/center/inactive?id=${id}`,
        {},
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        }
      );
      refetch();

      return result;
    },
  });
};

export const useGetWorkLocations = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["work locations"],
    staleTime: 1200,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/workLocation`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useAssignUserToWarehouse = () => {
  const { user } = useAuth() as AuthContextValue;
  const { refetch } = useWarehouseList();
  return useMutation({
    mutationFn: async (data: {
      userId: number;
      regionId: number;
      zoneId: number;
    }) => {
      const result = await axiosBaseURL.post(`/admin/assignLocation`, data, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      refetch();
      return result;
    },
  });
};
